import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { trigger, style, animate, transition, state } from '@angular/animations';
import { UserService } from '../../../shared/_services/user.service';
import { AuthenticationService } from '../../../shared/_services/authentication.service';
import { User } from '../../../shared/models/user.model';
import { IQuestion, Question } from '../../../shared/models/question.model';
import { UtilitiesService } from '../../../shared/_services/utilities.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';


@Component({
  selector: 'app-first-time',
  templateUrl: './first-time.component.html',
  styleUrls: ['./first-time.component.css'],
  animations: [
    trigger('enterState', [
        state('void', style({
          opacity: 0.2,
          transform: 'translateX(-100%)'          
        })),
        transition(':enter',[
          animate(300, style({
            opacity: 1,
            transform: 'translateX(0)'
        }))
      ])
    ]) 
  ]
})


export class FirstTimeComponent implements OnInit {

  firstTimeForm: FormGroup;
  questionList: IQuestion[]; 
  error = '';
  user: User;
  newPassword: string = '';
  confirmNewPassword: string = '';
  passvalid: boolean = true;

  preguntaseleccionada: Question = { idQuestion: 0, question: 'Seleccione una pregunta' }

  constructor(private formBuilder: FormBuilder,
    private _ultilitesService: UtilitiesService,
    private _userService: UserService,
    private _authenticationService: AuthenticationService,
    private router: Router
  ) { }

  ngOnInit() {
    //Carga la lista de preguntas
    this._ultilitesService.getAllQuestions()
      .subscribe(
      data => { this.questionList = data }
      );
    // carga validaciones y campos en blanco
    this.firstTimeForm = this.formBuilder.group({
      newPassword: ['', Validators.required],
      confirmNewPassword: ['', Validators.required],
      answer: ['', Validators.required],
    }); 

  }

  onBlurMethod() {
    //valida contraseñas iguales
    if (this.f.newPassword.value == this.f.confirmNewPassword.value) {
      this.passvalid = true;
    } else {
      this.passvalid = false;
      this.f.confirmNewPassword.setValue('');
    }
  }
 
  onSelect(pregunta: Question): void {
    this.preguntaseleccionada = pregunta;
  }
  // convenience getter for easy access to form fields
  get f() { return this.firstTimeForm.controls; }

  onSubmit() {
    // stop here if form is invalid
    if (this.firstTimeForm.invalid) {
      return;
    }

    this._userService.setFirstTime(this.preguntaseleccionada, this.f.confirmNewPassword.value, this.f.answer.value).pipe(first())
      .subscribe((data: User) => {    
        this._authenticationService.setCurrentUser(data);
        this.router.navigate(['/']);
      },
      error => {
        console.log("error")
        console.log(error)
          this.error = error;
        });
  }

  onCancel() {
    this._authenticationService.logout();
    this.router.navigate(['/']);
  }
}

